import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_ADDITION = "SHOP:GET_PRODUCT_ADDITION";

export const getProductAdditionAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_PRODUCT_ADDITION as typeof GET_PRODUCT_ADDITION,
  organization,
  id,
});

export type GetProductAdditionAction = ReturnType<
  typeof getProductAdditionAction
>;
